
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"19","viewBox":"0 0 24 19","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.75 14.816L2.891 9.959a1.366 1.366 0 00-1.943 0 1.366 1.366 0 000 1.943l5.817 5.817a1.383 1.383 0 001.957 0L23.438 3.016a1.366 1.366 0 000-1.943 1.366 1.366 0 00-1.944 0L7.75 14.816z","fill":"#16D2AA"}})])
          )
        }
      }
    